import React, { useEffect, useRef, useState } from 'react';
import { differenceInSeconds } from 'date-fns';
import { Typography } from '@cp/ds/src/components/typography';
import { DateISOString } from '@common/types';

export interface CountdownProps {
  deadline: DateISOString;
  onFinished?: () => void;
}
const secondsToDeadline = (deadline: DateISOString): number => {
  const diff = differenceInSeconds(new Date(deadline), new Date());
  return diff > 0 ? diff : 0;
};

export const Countdown: React.FC<CountdownProps> = ({ deadline, onFinished }) => {
  const [secondsLeft, setSeconds] = useState(() => secondsToDeadline(deadline));
  const intervalId = useRef<number>();
  useEffect(() => {
    const update = () => {
      const left = secondsToDeadline(deadline);
      setSeconds(left);
      if (!left) {
        clearInterval(intervalId.current);
        setTimeout(() => onFinished?.(), 1000);
      }
    };
    intervalId.current = setInterval(update, 1000) as unknown as number;
    return () => clearInterval(intervalId.current);
  }, [deadline]);
  return <Typography variant="caption bold">{secondsLeft} сек</Typography>;
};
